<script lang="ts">
    import { replace } from 'svelte-spa-router'
    import type DataProvider from '../services/data.provider'
    import type ServiceProvider from '../services/service.provider'
    import Summary from '../components/Summary.svelte'
    import Form from '../components/Form.svelte'
    import Breadcrumb from '../components/Breadcrumb.svelte'
    import { t } from '../lib/i18n/t';

    export let dataProvider: DataProvider
    export let serviceProvider: ServiceProvider

    if (null === dataProvider.activityId) {
        void replace("/")
    }

    async function formSubmitted(): Promise<any> {
        await replace(`/${t('page.odeslano')}`)
    }
</script>

<Breadcrumb contactSection={true} {dataProvider} {serviceProvider}/>
<div class="bno-container bno-container--centered">
    <div class="bno-container__content">
        <h2>{t('form.naKohoSeBudemeTesit')}</h2>
        <ul class="bno-grid bno-grid--x2 bno-grid--gap-40 bno-list--plain">
            <li class="bno-grid__tile">
                <Form {dataProvider} submitted={formSubmitted}/>
            </li>
            <li class="bno-grid__tile">
                <Summary {dataProvider} {serviceProvider}/>
            </li>
        </ul>
    </div>
</div>
